<template>
<div class="chapter">
<div class="inner_page">
<h1 class="calibre3" id="pgepubid00000">Tour Through The Eastern Counties Of England, 1722</h1>
<h3 class="c sigil_not_in_toc"><span class="gutsmall">BY</span><br class="calibre1"/>
  DANIEL DEFOE</h3>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0001.vue?962e7fa2